export type { InvestmentSchema } from './types';
export { default as schema } from './schema';
